import React from 'react';
import { TwitterEmbed as Twitter } from 'react-social-media-embed';

export const TwitterEmbed = ({ url }) => <Twitter url={url} />;
